import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import Badge from 'four-nets/ui-v2/badges/badge/badge';

import { SelectionItemsFragment } from './selection-items.graphql';
import defaultStyles from './selection-items.scss';

export interface Props {
    styles: typeof defaultStyles;
    selectionItems: SelectionItemsFragment['selectionItems'];
    collapse?: boolean;
}

class SelectionItems extends React.PureComponent<Props> {
    render() {
        const { styles, selectionItems, collapse } = this.props;

        const edges =
            selectionItems && selectionItems.edges
                ? collapse
                    ? selectionItems.edges.slice(0, 3)
                    : selectionItems.edges
                : null;

        return edges ? (
            <React.Fragment>
                {edges.map(edge =>
                    edge && edge.node ? (
                        <Link
                            key={edge.node.id}
                            to={`/blogs/?selection=${edge.node.translationKey}`}
                            className={styles.link}
                        >
                            <Badge style={{ badge: styles.badge }} uppercase={true} key={edge.node.id}>
                                {edge.node.name}
                            </Badge>
                        </Link>
                    ) : null
                )}
                {collapse && edges.length > 3 ? (
                    <Badge style={{ badge: styles.badge }} uppercase={true}>
                        <FormattedMessage id='MORE_SELECTION_ITEMS' values={{ count: edges.length - 3 }} />
                    </Badge>
                ) : null}
            </React.Fragment>
        ) : null;
    }
}

export default Styled(defaultStyles)(SelectionItems);
